module.exports = App.BusinessRole = DS.Model.extend
  name:          DS.attr 'string'
  organization: DS.belongsTo 'organization', async: true

  staff_members: DS.hasMany 'staff_member', async: true

  reports_access: DS.attr 'boolean'
  permitted_statuses: DS.attr 'mixed'

  privileges: DS.attr 'mixed'
